<template>
    <div class="flex contact-table-actions">
        <button class="block w-full px-4 py-2 text-base leading-5 text-left text-gray-400 hover:text-blue-400 transition duration-150 ease-in-out">
            <font-awesome-icon :icon="['far', 'eye']"></font-awesome-icon><span class="sr-only">View</span>
        </button>
    </div>
</template>

<script>

export default {
    name: "KeywordActionItems",
}
</script>

<style scoped>
    .contact-table-actions {
        max-width: 40px;
    }
</style>
